import { observable, action, makeObservable } from 'mobx';
import { getRegistrationList } from '@/api/myRegistration';

class RegistrationStore {
    constructor() {
        makeObservable(this);
    }

    @observable page_num = 1;
    @observable page_size = 8;
    @observable audit_state = undefined;
    @observable total = 0;
    @observable loading = true;
    @observable registration_list = [];

    @action
    setRegistrationList = (data) => {
        this.registration_list = data;
    };

    @action setState = (key, value, is_concat = false) => {
        if (is_concat) {
            this[key] = Object.assign(this[key], value);
        } else {
            this[key] = value;
        }
    };

    getList = async () => {
        this.setState('loading', true, false);
        const { data, total } = await getRegistrationList({
            page_num: this.page_num,
            page_size: this.page_size,
            audit_state: this.audit_state === -1 ? undefined : this.audit_state
        });
        this.setRegistrationList(data);
        this.setState('total', total);
        this.setState('loading', false, false);
    };
}

export default new RegistrationStore();
